import { useState } from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";

import actions from "@/actions";
import { Button, Input } from "@/components";

import Row from "./Row";
import TabContent from "./TabContent";

const StyledInput = styled(Input)`
    && {
        margin: 0 15px 0 15px;
        width: 94px;
    }
`;

/**
 * Tab for shifting all lights on the map by specified X and Y offsets in feet.
 *
 * @returns The rendered bulk shift tab.
 */
const BulkShift = () => {
    const dispatch = useDispatch();
    const [values, setValues] = useState({});
    const onShift = (x, y) =>
        dispatch(actions.map.advancedOperations.shiftLights(x, y));
    return (
        <TabContent>
            <Row>
                {"You can shift all lights on the map along " +
                    "the x axis (horizontally left or right) " +
                    "and/or along the y axis (vertically up and down). " +
                    "To shift left or down, enter a negative value."}
            </Row>
            <Row>
                <StyledInput
                    label="Shift X (ft)"
                    value={values.x}
                    onChange={(value) => setValues({ x: value, y: values.y })}
                    decimalDigits={3}
                    type="number"
                />
                <StyledInput
                    label="Shift Y (ft)"
                    value={values.y}
                    onChange={(value) => setValues({ y: value, x: values.x })}
                    decimalDigits={3}
                    type="number"
                />
            </Row>
            <Row>
                <Button
                    disabled={
                        (!values.x ||
                            values.x === "0" ||
                            values.x === "0." ||
                            values.x === "-") &&
                        (!values.y ||
                            values.y === "0" ||
                            values.y === "0." ||
                            values.y === "-")
                    }
                    onClick={() => onShift(values.x, values.y)}
                >
                    {"Shift All Lights"}
                </Button>
            </Row>
        </TabContent>
    );
};

export default BulkShift;
